<script>
import Vue from "vue";
import Drawer from "vue-simple-drawer";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { required } from "vuelidate/lib/validators";
import Multiselect from "vue-multiselect";
import { userGridData } from "./data-user";
import Swal from "sweetalert2";
import simplebar from "simplebar-vue";
import axios from "axios";
/**
 * team-list component
 */

export default {
  page: {
    title: "Teams",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Drawer, Layout, PageHeader, Multiselect, simplebar },
  data() {
    return {
      loginData: {},
      userGridData: userGridData,
      companyId: null,
      title: "Teams",
      open: false,
      teams: [

      ],
      openRightDrawer: false,
      isUpDrawer: false,
      isDownDrawer: false,
      showModal: false,
      showEditModal: false,
      showAddEmpModal: false,
      showRuleModal: false,
      submitted: false,
      selectAllTeam: false,
      applyRuleSubmit: false,
      applyTeamSubmit : false,
      submittedEdit: false,
      users: {
        name: "",
        designation: "",
        email: "",
      },
      onChangeRuleEditTeamVal: false,
      teamListLoader: false,
      vacantTeam: {
        teamId: null,
        managerEmpId: "",
        companyId: 0,
        rule : null,
        override: false,
        teamName: "",
        teamDescription:"",
        employees:[
        ],
        projects:[
        ],
      },
      addedTeam: {
        teamId: null,
        managerEmpId: null,
        companyId: 0,
        rule : null,
        override: false,
        teamName: "",
        teamDescription:"",
        employees:[
        ],
        projects:[
        ],
      },
      selectedTeam: {
      },
      selectedTeamForEdit: {
      },
      selectedTeamForRule: {
      },
      selectedTeamForAddEmp: {
      },
      value1: null,
      filterValue: "",
      filterEmpValue: "",
      defaultEmployeeOptions: [],
      employeeOptions: [
      ],
      defaultTeamEmployeeOptions: [
      ],
      projectOptions: [
      ],
      ruleOptions: [
        {
          value: 1000000,
          text: "DEFAULT RULE",
        },
      ],
    };
  },
  validations: {
    addedTeam: {
      teamName: { required },
      managerEmpId: { required },
    },
    selectedTeamForEdit: {
      teamName: { required },
      manager: { required },
    },
  },
  methods: {
    /**
     * Modal form submit
     */
    // eslint-disable-next-line no-unused-vars
    async getAllRules() {
      try {
        const response = await axios.get(process.env.VUE_APP_EMPLOYEE_URL + "/rule/get_all", {
          params: { companyId: this.loginData.companyId },
        });
         if(response.data.success == "true") {
          for (var i = 0; i < response.data.data.length; i++) {
            var d = {};
            d.value = response.data.data[i].ruleId;
            d.text = response.data.data[i].ruleName;

            this.ruleOptions.push(d);
          }
        }
      } catch (error) {
       // console.log(error);
      }
    },
    async getAllEmployees() {
      this.defaultEmployeeOptions = [];
      try {
        const response = await axios.get(process.env.VUE_APP_EMPLOYEE_URL + "/employee/get_all",
          { params: { companyId: this.loginData.companyId } }
        );
        if(response.data.success == "true") {
          if(response.data.data.length > 0) {
            for(var i = 0;i < response.data.data.length; i++) {
              var d = {};
              d.value = response.data.data[i].empId;
              d.text = response.data.data[i].name;
              if(response.data.data[i].teamId == 1000000){
                this.defaultEmployeeOptions.push(d);
              }
            }
          }
        }
      } catch (error) {
        //console.log(error);
      }
    },
    async getAllProjects() {
      try {
        const response = await axios.get(
          process.env.VUE_APP_EMPLOYEE_URL + "/project/get_all",
          { params: { companyId: this.loginData.companyId } }
        );
        if(response.data.success == "true") {
          for (var i = 0; i < response.data.data.length; i++) {
            var d = {};
            d.value = response.data.data[i].projectId;
            d.text = response.data.data[i].projectName;

            this.projectOptions.push(d);
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    selectAllTeamCheckbox() {
      for(var i =0;i< this.teams.length;i++) {
        this.teams[i].isChecked = this.selectAllTeam;
      }
    },
    async getAllTeams() {
      this.teamListLoader = true;
       this.teams = [];
      try {
        const response = await axios.get(process.env.VUE_APP_EMPLOYEE_URL + "/team/get_all",
          { params: { companyId: this.loginData.companyId } }
        );
         if(response.data.success == "true") {
            if(response.data.data.length > 0) {
              this.teams = response.data.data;
              for(var i = 0;i < this.teams.length; i++) {
                this.teams[i].isChecked = false;
                var r = {};
                r.value = this.teams[i].ruleId;
                r.text = this.teams[i].ruleName;
                this.teams[i].emps = [];
                for(var j=0;j< this.teams[i].employees.length;j++) {
                  if(this.teams[i].employees[j].empId == this.teams[i].managerEmpId) {
                    this.teams[i].managerName = this.teams[i].employees[j].empName;
                  }
                  var e = {};
                  e.value = this.teams[i].employees[j].empId;
                  e.text = this.teams[i].employees[j].empName;
                  this.teams[i].emps.push(e);
                }
                this.teams[i].rule = r;
                var m = {};
                m.value = this.teams[i].managerEmpId;
                m.text = this.teams[i].managerName;
                this.teams[i].manager = m;

                this.teams[i].override = false;
              }
            }
          }
      } catch (error) {
        //.log(error);
      }
      this.teamListLoader = false;
    },
    editTeam(data) {
      this.selectedTeamForEdit = JSON.parse(JSON.stringify(data));
      this.defaultTeamEmployeeOptions = [];
      this.defaultTeamEmployeeOptions = JSON.parse(JSON.stringify(this.defaultEmployeeOptions));

      for(var i = 0;i < this.selectedTeamForEdit.emps.length;i++) {
        var d = {};
        d.value = this.selectedTeamForEdit.emps[i].value;
        d.text = this.selectedTeamForEdit.emps[i].text;

        this.defaultTeamEmployeeOptions.push(d);
      }

      this.showEditModal = true;
    },
    addEmployee(data) {
      this.selectedTeamForAddEmp = JSON.parse(JSON.stringify(data));
      this.showAddEmpModal= true;
    },
    applyRule(data) {
      this.selectedTeamForRule = JSON.parse(JSON.stringify(data));
      this.showRuleModal = true;
    },
    nameWithLang({ text }) {
      return `${text}`;
    },
    handleAddTeamSubmit() {
      this.submitted = true;
      this.$v.addedTeam.$touch();
      if (this.$v.addedTeam.$invalid) {
        return;
      } else {
        this.addedTeam.companyId = this.loginData.companyId;
        var d = {};
        d.value = this.addedTeam.managerEmpId.value;
        d.text = this.addedTeam.managerEmpId.text;
        this.addedTeam.employees.push(d);

        let formData = new FormData();
        formData.append("team", JSON.stringify(this.addedTeam));

        axios
            .post(process.env.VUE_APP_EMPLOYEE_URL + `/team/add`, formData)
            .then((res) => {
              if(res.data.success == "true") {
                this.showModal = false;
                Swal.fire({
                  title: "Added!",
                  text: "Team has been Added.",
                  icon: 'success',
                  onClose: () => {
                    this.getAllEmployees();
                    this.getAllTeams();
                    this.addedTeam = JSON.parse(JSON.stringify(this.vacantTeam));
                  }
                });
                
              } else {
                this.showModal = false;
                Vue.swal(res.data);
              }
              return res;
            })
            .catch((err) => {
              this.showModal = false;
              Vue.swal("Oops! Some Error Occured.");
              return err;
            });
      }
      this.submitted = false;
    },
    handleEditTeamSubmit() {
      
      this.submittedEdit = true;
      this.$v.selectedTeamForEdit.$touch();
      if (this.$v.selectedTeamForEdit.$invalid) {
        
        return;
      } else {
      var d = {};
      d.value = this.selectedTeamForEdit.manager.value;
      d.text = this.selectedTeamForEdit.manager.text;
      this.selectedTeamForEdit.employees.push(d);

      let formData = new FormData();
      formData.append("team", JSON.stringify(this.selectedTeamForEdit));

      axios
          .post(process.env.VUE_APP_EMPLOYEE_URL + `/team/edit`, formData)
          .then((res) => {
            if(res.data.success == "true") {
                this.showEditModal = false;
                Swal.fire({
                  title: "Edited!",
                  text: "Team has been Edited.",
                  icon: 'success',
                  onClose: () => {
                    this.getAllEmployees();
                    this.getAllTeams();
                  }
                });
                
              } else {
                this.showEditModal = false;
                Vue.swal(res.data);
              }
            return res;
          })
          .catch((err) => {
            this.showEditModal = false;
            Vue.swal("Oops! Some Error Occured.");
            return err;
          });
      }
      this.submittedEdit = false;
    },
    handleApplyRuleSubmit() {
      this.applyRuleSubmit = true;
      if(this.selectedTeamForRule.rule == null){
        return;
      }
      let formData = new FormData();
      formData.append("companyId", this.selectedTeamForRule.companyId);
      formData.append("teamId", this.selectedTeamForRule.teamId);
      formData.append("ruleId", this.selectedTeamForRule.rule.value);
      formData.append("oldRuleId", this.selectedTeamForRule.ruleId);

      axios
        .post(process.env.VUE_APP_EMPLOYEE_URL + `/team/apply_rule`, formData)
        .then((res) => {
          alert(res);
          
          return res;
        })
        .catch((err) => {
          return err;
        });
      this.applyRuleSubmit = false;
    },
    handleAddEmpSubmit() {
      this.applyTeamSubmit = true;
      if(this.selectedTeamForAddEmp.employees == null){
        return;
      }
      let formData = new FormData();
      formData.append("companyId", this.selectedTeamForAddEmp.companyId);
      formData.append("teamId", this.selectedTeamForAddEmp.teamId);
      formData.append("ruleId", this.selectedTeamForAddEmp.rule.value);
      formData.append("oldRuleId", this.selectedTeamForAddEmp.ruleId);

      axios
        .post(process.env.VUE_APP_EMPLOYEE_URL + `/team/apply_rule`, formData)
        .then((res) => {
          alert(res);
          return res;
        })
        .catch((err) => {
          return err;
        });
      this.applyTeamSubmit = false;
    },
    confirm() {
      let ischeckedTeam = false;
      let sendData = "";

      for(var i = 0;i < this.teams.length;i++) {
        if(this.teams[i].isChecked == true) {
          ischeckedTeam = true;
          sendData = sendData.concat(",", this.teams[i].teamId);
        }
      }
      sendData = sendData.substring(1);

      if(ischeckedTeam == false) {
        Vue.swal("Please Select Team.");
      } else {
        Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#f46a6a",
          confirmButtonText: "Yes, delete it!",
        }).then((result) => {
          if (result.value) {
            this.deleteTeam(sendData);
          }
        });
      }
    },
    deleteTeam(senddData) {
      let formData = new FormData();
      formData.append("teamIds", senddData);

      axios
          .post(process.env.VUE_APP_EMPLOYEE_URL + `/team/delete`, formData)
          .then((res) => {
            if(res.data.success == "true") {
                this.getAllTeams();
                this.showEditModal = false;
                Swal.fire("Deleted!", "Team(s) have been deleted.", "success");
              } else {
                this.showEditModal = false;
                Vue.swal(res.data);
              }
            return res;
          })
          .catch((err) => {
            this.showEditModal = false;
            Vue.swal("Oops! Some Error Occured.");
            return err;
          });
    },
    onChangeRuleEditTeam() {
      this.onChangeRuleEditTeamVal = true;
    },
    handleToggleDrawer() {
      this.$refs.drawerLayout.toggle();
    },
    goToEmployee() {
      this.$router.push({ name: 'Detailed Analysis - Attendance and Leave', params: { id: 'siddharth' }});
    },
    toggle() {
      this.open = !this.open;
    },
    rightDrawer(val) {
      this.selectedTeam = val;
      this.openRightDrawer = !this.openRightDrawer;
    },
    upDrawer() {
      this.isUpDrawer = !this.isUpDrawer;
    },
    downDrawer() {
      this.isDownDrawer = !this.isDownDrawer;
    },
  },
  created() {
    this.loginData = JSON.parse(localStorage.getItem('user'));
    this.getAllTeams();
    this.getAllEmployees();
    //this.getAllProjects();
    this.getAllRules();
  },
  computed: {
    searchevents: function() {
      var result = this.teams;
      if (!this.filterValue)
        return result;
      
      const filterValue = this.filterValue.toLowerCase();

      const filter = event => 
          event.teamName.toLowerCase().includes(filterValue);
      
      return result.filter(filter);
    },
    searchEmpevents: function() {
      var result = this.selectedTeam.employees;
      if (!this.filterEmpValue)
        return result;
      
      const filterEmpValue = this.filterEmpValue.toLowerCase();

      const filter = event => 
          event.empName.toLowerCase().includes(filterEmpValue);
      
      return result.filter(filter);
    },
  },
  
};
</script>

<template>
  <Layout>
    <PageHeader :title="$t('menuitems.teams.text')" />
    <div class="row">
      <div class="search-box  col-sm-4 mb-2">
        <div class="position-relative">
          <input
            type="text"
            class="form-control"
            :placeholder="$t('menuitems.teams.search')"
            v-model="filterValue"
          />
          <i class="bx bx-search-alt search-icon"></i>
        </div>
      </div>
      <div class="col-sm-8 mb-2">
        <div class="text-sm-end">
          <button
            class="btn btn-success mb-2 me-2"
            @click="showModal = true"
          >
            <i class="mdi mdi-plus me-1"></i> {{ $t("menuitems.teams.add") }}
          </button>
          <button class="btn btn-danger mb-2 me-2" @click="confirm">
            <i class="mdi mdi-account-remove"></i> {{ $t("menuitems.teams.remove") }}
          </button>
        </div>
      </div>
    </div>
    <b-modal v-model="showModal" size="xl" :title="$t('menuitems.teams.addTeam')" hide-footer>
      <form @submit.prevent="handleAddTeamSubmit">
        <div class="row">
          <div class="col-12">
            <div class="mb-3">
              <label for="name">{{ $t("menuitems.teams.team") }} {{ $t("menuitems.teams.name") }}</label>
              <input
                id="name"
                v-model="addedTeam.teamName"
                type="text"
                class="form-control"
                :placeholder="$t('menuitems.teams.enterName')"
                :class="{
                  'is-invalid': submitted && $v.addedTeam.teamName.$error,
                }"
              />
              <div
                v-if="submitted && !$v.addedTeam.teamName.required"
                class="invalid-feedback"
              >
                {{ $t("menuitems.teams.text") }} {{ $t("menuitems.teams.name") }} is required.
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="mb-3">
              <label for="projects">{{ $t("menuitems.teams.text") }} {{ $t("menuitems.teams.head") }}</label>
              <multiselect
                v-model="addedTeam.managerEmpId"
                :options="defaultEmployeeOptions"
                :placeholder="$t('menuitems.teams.selectOption')"
                :class="{
                  'is-invalid': submitted && $v.addedTeam.managerEmpId.$error,
                }"
                :custom-label="nameWithLang"
                track-by="text"
              ></multiselect>
              <div
                v-if="submitted && !$v.addedTeam.managerEmpId.required"
                class="invalid-feedback"
              >
                {{ $t("menuitems.teams.text") }} {{ $t("menuitems.teams.head") }} is required.
              </div>
            </div>
            
          </div>
          <div class="col-12 mb-2">
            <label for="employees">{{ $t("menuitems.teams.add") }} {{ $t("menuitems.teams.employees") }}</label>
            <multiselect
              v-model="addedTeam.employees"
              :options="defaultEmployeeOptions"
              :custom-label="nameWithLang"
              :placeholder="$t('menuitems.teams.selectOption')"
              :multiple="true"
              track-by="text"
            ></multiselect>
          </div>
          <!--<div class="col-12">
            <label for="projects">Projects</label>
            <multiselect
              v-model="addedTeam.projects"
              :options="projectOptions"
              :custom-label="nameWithLang"
              :multiple="true"
              track-by="text"
            ></multiselect>
          </div>-->
        </div>
        <div class="col-12">
            <div class="mb-3">
              <label for="rule">{{ $t("menuitems.teams.applyRule") }}</label>
              <multiselect
                v-model="addedTeam.rule"
                :options="ruleOptions"
                :placeholder="$t('menuitems.teams.selectOption')"
                :custom-label="nameWithLang"
                track-by="text"
              ></multiselect>
            </div>
        </div>
        <div v-if="addedTeam.rule!=null" class="col-12">
          <div class="row">
            <div class="col-9 mb-3">
              <span class="text-danger me-3">{{ $t("menuitems.teams.note") }}</span>
              
            </div>
            <div class="col-3 mb-3">
              <span class="me-2">{{ $t("menuitems.teams.selectToOverride") }}</span> <input type="checkbox" v-model="addedTeam.override"/>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="mb-3">
            <label for="description">{{ $t("menuitems.teams.text") }} {{ $t("menuitems.teams.description") }}</label>
            <input
              id="name"
              v-model="addedTeam.teamDescription"
              type="text"
              class="form-control"
              :placeholder="$t('menuitems.teams.enterDescription')"
            />
          </div>
        </div>
        <div class="text-end mt-3">
          <b-button variant="light" @click="showModal = false">{{ $t("menuitems.teams.close") }}</b-button>
          <b-button type="submit" variant="success" class="ms-1"
            >{{ $t("menuitems.teams.addTeam") }}</b-button
          >
        </div>
      </form>
    </b-modal>
    
    <b-modal v-model="showEditModal" size="xl" :title="$t('menuitems.teams.editTeam')" hide-footer>
      <form @submit.prevent="handleEditTeamSubmit">
        <div class="row">
          <div class="col-12">
            <div class="mb-3">
              <label for="name">{{ $t("menuitems.teams.team") }} {{ $t("menuitems.teams.name") }}</label>
              <input
                id="name"
                v-model="selectedTeamForEdit.teamName"
                type="text"
                class="form-control"
                :placeholder="$t('menuitems.teams.enterName')"
                :class="{
                  'is-invalid': submittedEdit && $v.selectedTeamForEdit.teamName.$error,
                }"
              />
              <div
                v-if="submittedEdit && !$v.selectedTeamForEdit.teamName.required"
                class="invalid-feedback"
              >
                {{ $t("menuitems.teams.text") }} {{ $t("menuitems.teams.name") }} is required.
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="mb-3">
              <label for="projects">{{ $t("menuitems.teams.text") }} {{ $t("menuitems.teams.head") }}</label>
              <multiselect
                v-model="selectedTeamForEdit.manager"
                :options="defaultTeamEmployeeOptions"
                :class="{
                  'is-invalid': submittedEdit && $v.selectedTeamForEdit.manager.$error,
                }"
                :placeholder="$t('menuitems.teams.selectOption')"
                :custom-label="nameWithLang"
                track-by="text"
              ></multiselect>
              <div
                v-if="submittedEdit && !$v.selectedTeamForEdit.manager.required"
                class="invalid-feedback"
              >
                {{ $t("menuitems.teams.text") }} {{ $t("menuitems.teams.head") }} is required.
              </div>
            </div>
            
          </div>
          <div class="col-12">
            <label for="employees">{{ $t("menuitems.teams.text") }} {{ $t("menuitems.teams.employees") }}</label>
            <multiselect
              v-model="selectedTeamForEdit.emps"
              :options="defaultTeamEmployeeOptions"
              :placeholder="$t('menuitems.teams.selectOption')"
              :custom-label="nameWithLang"
              :multiple="true"
              track-by="text"
            ></multiselect>
          </div>
          <!--<div class="col-12">
            <label for="projects">Projects</label>
            <multiselect
              v-model="selectedTeamForEdit.projects"
              :options="projectOptions"
              :custom-label="nameWithLang"
              :multiple="true"
              track-by="text"
            ></multiselect>
          </div>-->
        </div>
        <div class="col-12">
            <div class="mb-3">
              <label for="rule">{{ $t("menuitems.teams.applyRule") }}</label>
              <multiselect
                v-model="selectedTeamForEdit.rule"
                :options="ruleOptions"
                :placeholder="$t('menuitems.teams.selectOption')"
                :custom-label="nameWithLang"
                @input="onChangeRuleEditTeam"
                track-by="text"
              ></multiselect>
            </div>
        </div>
        <div v-if="onChangeRuleEditTeamVal && selectedTeamForEdit.rule != null" class="col-12">
          <div class="row">
            <div class="col-9 mb-3">
              <span class="text-danger me-3">{{ $t("menuitems.teams.note") }}</span>
              
            </div>
            <div class="col-3 mb-3">
              <span class="me-2">{{ $t("menuitems.teams.selectToOverride") }}</span> <input type="checkbox" v-model="selectedTeamForEdit.override"/>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="mb-3">
            <label for="description">{{ $t("menuitems.teams.text") }} {{ $t("menuitems.teams.description") }}</label>
            <input
              id="name"
              v-model="selectedTeamForEdit.enterDescription"
              type="text"
              class="form-control"
              :placeholder="$t('menuitems.teams.enterDescription')"
            />
          </div>
        </div>
        <div class="text-end mt-3">
          <b-button variant="light" @click="showEditModal = false">{{ $t("menuitems.teams.close") }}</b-button>
          <b-button type="submit" variant="success" class="ms-1"
            >{{ $t("menuitems.teams.editTeam") }}</b-button
          >
        </div>
      </form>
    </b-modal>

    <!--<b-modal v-model="showAddEmpModal" size="xl" title="Add Employee" centered hide-footer>
      <form @submit.prevent="handleAddEmpSubmit">
        <div class="row">
          <div class="col-12">
            <label for="employees">Team Employees</label>
            <multiselect
              v-model="selectedTeamForAddEmp.emps"
              :options="defaultTeamEmployeeOptions"
              :custom-label="nameWithLang"
              track-by="text"
              :multiple="true"
              :class="{
                        'is-invalid': applyRuleSubmit && (selectedTeamForRule.rule == null),
                      }"
            ></multiselect>
             <div
                v-if="applyRuleSubmit && (selectedTeamForRule.rule == null)"
                class="invalid-feedback"
              >
                Employees are required.
              </div>
          </div>
        </div>
        <div class="text-end mt-3">
          <b-button variant="light" @click="showAddEmpModal = false">Close</b-button>
          <b-button type="submit" variant="success" class="ms-1"
            >Add Employee</b-button
          >
        </div>
      </form>
    </b-modal>

    <b-modal v-model="showRuleModal" title="Apply Rule" centered hide-footer>
      <form @submit.prevent="handleApplyRuleSubmit">
        <div class="row">
          <div class="col-12">
            <div class="mb-3">
              <label for="rule">Apply Rule</label>
              <multiselect
                v-model="selectedTeamForRule.rule"
                :options="ruleOptions"
                :custom-label="nameWithLang"
                track-by="text"
                 :class="{
                        'is-invalid': applyRuleSubmit && (selectedTeamForRule.rule == null),
                      }"
              ></multiselect>
              <div
                v-if="applyRuleSubmit && (selectedTeamForRule.rule == null)"
                class="invalid-feedback"
              >
                Rule is required.
              </div>
            </div>
        </div>
        </div>
        <div class="text-end mt-3">
          <b-button variant="light" @click="showRuleModal = false">Close</b-button>
          <b-button type="submit" variant="success" class="ms-1"
            >Apply Rule</b-button
          >
        </div>
      </form>
    </b-modal>-->

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="is-loading">
                <div class="preloader-component" v-show="teamListLoader">
                  <div class="status">
                    <div class="spinner-chase">
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                    </div>
                  </div>
                </div>
            <div class="card-body" style="height: calc(100vh - 274px);">
              <simplebar ref="current"  v-if="searchevents.length > 0" style="max-height: calc(100vh - 300px);">
                
                <div class="table-responsive">
                  <table class="table align-middle table-nowrap table-hover">
                    <thead class="table-light">
                      <tr>
                        <th scope="col" style="width: 70px"><div class="form-check font-size-14 mb-0">
                            <input
                            v-model="selectAllTeam"
                              type="checkbox"
                              class="form-check-input"
                              @change="selectAllTeamCheckbox"
                            />
                            <label
                              class="form-check-label"
                              >&nbsp;</label
                            >
                          </div></th>
                        <th scope="col">{{ $t("menuitems.teams.name") }}</th>
                        <th scope="col">{{ $t("menuitems.teams.members") }}</th>
                        <th scope="col">{{ $t("menuitems.teams.monitoringRules") }}</th>
                        <!--<th scope="col">Productivity</th>-->
                        <th scope="col">{{ $t("menuitems.teams.action") }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="list of searchevents" :key="list.teamId">
                        <td>
                          <div class="form-check font-size-14 mb-0">
                            <input
                                v-model="list.isChecked"
                                type="checkbox"
                                class="form-check-input"
                              />
                            <label
                              class="form-check-label"
                              :for="`customCheck${list.teamId}`"
                              >&nbsp;</label
                            >
                          </div>
                        </td>
                        <td>
                          <h5 class="font-size-14 mb-1">
                            <a href="#" class="text-dark">{{ list.teamName }}</a>
                          </h5>
                        </td>
                        <td>
                          <div class="avatar-group">
                            <div class="avatar-group-item" v-if="list.employees.length >= 1" @click="rightDrawer(list)">
                              <div v-if="!list.image" class="avatar-xs">
                                <span class="avatar-title rounded-circle bg-soft bg-success text-primary">{{
                                  list.employees[0].empName.charAt(0)
                                }}</span>
                              </div>
                              <div v-if="list.image">
                                <img
                                  class="rounded-circle avatar-xs"
                                  :src="`${list.image}`"
                                  alt
                                />
                              </div>
                            </div>
                            <div class="avatar-group-item" v-if="list.employees.length >= 2" @click="rightDrawer(list)">
                              <div v-if="!list.image" class="avatar-xs">
                                <span class="avatar-title rounded-circle bg-soft bg-primary text-primary">{{
                                  list.employees[1].empName.charAt(0)
                                }}</span>
                              </div>
                              <div v-if="list.image">
                                <img
                                  class="rounded-circle avatar-xs"
                                  :src="`${list.image}`"
                                  alt
                                />
                              </div>
                            </div>
                            <div class="avatar-group-item" v-if="list.employees.length >= 3" @click="rightDrawer(list)">
                              <div v-if="!list.image" class="avatar-xs">
                                <span class="avatar-title rounded-circle bg-soft bg-warning text-primary">{{
                                  list.employees[2].empName.charAt(0)
                                }}</span>
                              </div>
                              <div v-if="list.image">
                                <img
                                  class="rounded-circle avatar-xs"
                                  :src="`${list.image}`"
                                  alt
                                />
                              </div>
                            </div>
                            <div class="avatar-group-item" v-if="list.employees.length >= 4" @click="rightDrawer(list)">
                              <div v-if="!list.image" class="avatar-xs">
                                <span class="avatar-title rounded-circle bg-soft bg-warning text-primary">{{
                                  list.employees[3].empName.charAt(0)
                                }}</span>
                              </div>
                              <div v-if="list.image">
                                <img
                                  class="rounded-circle avatar-xs"
                                  :src="`${list.image}`"
                                  alt
                                />
                              </div>
                            </div>
                            <!--<div class="avatar-group-item " v-b-tooltip.hover style="cursor: pointer" title="Add Employee" @click="addEmployee(list)">
                              <div class="avatar-xs">
                                <span class="avatar-title rounded-circle bg-soft bg-info text-primary fs-3">+</span>
                              </div>
                            </div>-->
                          </div>
                        </td>
                        <td>
                          <div>
                            <a
                              v-if="list.ruleName == 'DEFAULT RULE'"
                              href="javascript: void(0);"
                              class="badge badge-soft-primary font-size-13 m-1"
                              >{{ $t("menuitems.teams.defaultRule") }}</a
                            >
                            <a
                              v-else
                              href="javascript: void(0);"
                              class="badge badge-soft-primary font-size-13 m-1"
                              >{{ list.ruleName }}</a
                            >
                          </div>
                        </td>
                        <!--<td>
                          <div>
                            <span v-if="list.productivity >= 60" class="badge bg-success font-size-12">{{ list.productivity }} %</span>
                            <span v-else-if="list.productivity < 60 && list.productivity > 40" class="badge bg-warning font-size-12">{{ list.productivity }} %</span>
                            <span v-else class="badge bg-danger font-size-12">{{ list.productivity }} %</span>
                          </div>
                        </td>-->
                        <td>
                          <ul class="list-inline font-size-20 contact-links mb-0">
                            <li class="list-inline-item px-2">
                              <button @click="editTeam(list)" class="btn btn-primary btn-sm">
                                <i class="far fa-edit fs-6 me-1"></i> {{ $t("menuitems.teams.edit") }}
                              </button>
                            </li>
                            <!--<li class="list-inline-item px-2">
                              <span @click="showAddEmpModal = true" style="cursor: pointer;" v-b-tooltip.hover title="Delete">
                                <i class="fas fa-trash-alt fs-5 text-warning"></i>
                              </span>
                            </li>-->
                          </ul>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
            
              </simplebar>

              <div v-if="searchevents.length <= 0" style="margin-top: 15%;margin-left: 40%;">
                <img src="@/assets/images/no-data.png" alt="No Data"  height="180" width="180"><br />
                <span class="mt-2 text-secondary fw-bold fs-3">No Team Found</span>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <Drawer
      @close="rightDrawer"
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
    >
      <div v-if="openRightDrawer">
        <div class="offcanvas-header">
          <h4 class="offcanvas-title text-truncate" id="offcanvasExampleLabel" style="width:320px">
            {{selectedTeam.teamName}}
          </h4>
        </div>
        <div class="offcanvas-body mt-0">
          <p class="font-size-14"> {{selectedTeam.employees.length}} {{ $t("menuitems.teams.members")}}</p>
          <div class="search-box py-2">
          <div class="position-relative">
            <input type="text" class="form-control" placeholder="Search..." v-model="filterEmpValue" />
            <i class="bx bx-search-alt search-icon"></i>
          </div>
        </div>
           <div>
              <simplebar style="max-height: calc(100vh - 250px)">
                <ul class="list-unstyled chat-list">
                  <li
                    v-for="data of searchEmpevents"
                    :key="data.empId"
                  > 
                    <a href="javascript: void(0);">
                        <div class="row">
                          <div class="col-md-1">
                            <i :class="`mdi mdi-circle text-${data.color} font-size-10`"></i>
                          </div>
                          <div class="avatar-xs col-md-3" style="width:55px">
                            <span class="avatar-title rounded-circle bg-soft bg-primary text-primary">{{ data.empName.charAt(0) }}</span>
                          </div>
                          <div class="col-md-8">
                            <span class="text-truncate font-size-14 mb-1">{{ data.empName }} <span v-if="data.empId == selectedTeam.managerEmpId" class="text-primary">( {{ $t("menuitems.teams.head")}} )</span></span>
                            <p class="text-truncate mb-0">{{ data.empEmail }}</p>
                          </div>
                        </div>
                        
                    </a>
                  </li>
                </ul>
                </simplebar>
            </div>
        </div>
        
      </div>
    </Drawer>
  </Layout>
</template>
<style scoped>
.is-loading {
  position: relative;
}
.preloader-component {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  width: 100%;
  background-color: #fff;
}
.status {
  width: 40px;
  height: 40px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -20px 0 0 -20px;
}
</style>